import makeApiCall from "./axiosIndex";

interface DashboardParams {
  orgIds?: string;
  siteIds?: string;
  headerIds?: string;
  lineIds?: string;
  modules?: string;
  startDate?: string;
  endDate?: string;
  budgetCategoryIds?: string;
  contractorIds?: string;
}

interface ReportParams extends DashboardParams {
  page?: number;
  pageSize?: number;
  orderNumbers?: string;
  workOrderIds?: string;
  expenseReportIds?: string;
  prIds?: string;
  categoryIds?: string;
  workCategoryIds?: string;
  drillYear?: number;
  drillMonth?: number;
}

const DASHBOARD_BASE = "/budget-analysis-dashboard";
const REPORT_BASE = "/budget-analysis-report";

const budgetAnalysisDashboardApis = {
  summaryReport: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/summary-report`, params }),

  budgetVsActualByCategory: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/budget-vs-actual-by-category`, params }),

  budgetConsumptionBySource: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/budget-consumption-by-source`, params }),

  budgetHealthIndicator: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/budget-health-indicator`, params }),

  timeBudgetBurn: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/time-budget-burn`, params }),

  budgetDistributionByCategory: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/budget-distribution-by-category`, params }),

  budgetDistributionByLineItem: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/budget-distribution-by-line-item`, params }),

  budgetVsPurchaseOrders: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/budget-vs-purchase-orders`, params }),

  budgetVsWorkOrders: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/budget-vs-work-orders`, params }),

  budgetVsProjectTasks: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/budget-vs-project-tasks`, params }),

  expenseBudgetAnalysis: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/expense-budget-analysis`, params }),

  contractorCostPerformance: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/contractor-cost-performance`, params }),

  budgetVarianceAnalysis: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/budget-variance-analysis`, params }),

  forecastCostAtCompletion: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/forecast-cost-at-completion`, params }),

  budgetControlAlerts: (params?: DashboardParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${DASHBOARD_BASE}/budget-control-alerts`, params }),

  // ==================== REPORT APIs ====================

  projectBudgetVsActualSummary: (params?: ReportParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${REPORT_BASE}/project-budget-vs-actual-summary`, params }),

  budgetConsumptionByCategorySummary: (params?: ReportParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${REPORT_BASE}/budget-consumption-by-category-summary`, params }),

  contractorCostSummary: (params?: ReportParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${REPORT_BASE}/contractor-cost-summary`, params }),

  budgetVsPurchaseOrdersSummary: (params?: ReportParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${REPORT_BASE}/budget-vs-purchase-orders-summary`, params }),

  budgetVsExpensesSummary: (params?: ReportParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${REPORT_BASE}/budget-vs-expenses-summary`, params }),

  budgetVsWorkOrdersSummary: (params?: ReportParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${REPORT_BASE}/budget-vs-work-orders-summary`, params }),

  budgetUtilizationTrend: (params?: ReportParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${REPORT_BASE}/budget-utilization-trend`, params }),

  budgetForecastSummary: (params?: ReportParams): Promise<any> =>
    makeApiCall({ method: "get", url: `${REPORT_BASE}/budget-forecast-summary`, params }),
};

export default budgetAnalysisDashboardApis;
